module.exports = __webpack_public_path__ + "img/2.eca7b72b.jpg";